/** Blue verified tick (Facebook-style: blue circle with white check). */
export default function VerifiedTick({ className }: { className?: string }) {
  return (
    <span
      className={className}
      aria-label="Verified"
      title="Verified"
      role="img"
    >
      <svg viewBox="0 0 24 24" className="size-5" fill="none" aria-hidden>
        <circle cx="12" cy="12" r="10" fill="#1877F2" />
        <path
          d="M8 12l3 3 5-6"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
